import Icon from 'assets/components/icon/Icon';
import TextBox, { textBoxStyles } from 'assets/components/textBox/TextBox';
import { getLocales } from 'assets/locales/Locale';
import ObjectTable from 'assets/templates/objectTable/ObjectTable';
import { defaultDateTimeFormat, localizeDate } from 'assets/utils/data/Date';
import ClaimTypeDataPointInputType from 'models/enums/ClaimTypeDataPointInputType';
import { useClaimJobEdit } from './ClaimEdit.Job.Hooks';
import Box from 'assets/components/box/Box';
import ThemeWrapperGrid from 'assets/themes/wrappers/Theme.Wrapper.Grid';

export default function ClaimEditJobInfo() {
  const { lang } = getLocales();
  const { claimTypeReport, claimJob } = useClaimJobEdit();

  return (
    <>
      {!claimTypeReport && (
        <>
          <h3>{lang.details}</h3>
          <Box class={ThemeWrapperGrid}>
            <TextBox
              class={textBoxStyles.block.flexBlock}
              title={`${lang.authorizationNumber}:`}
              subtitle={claimJob.authorizationNumber ?? 'N/A'}
            />
            <TextBox
              class={textBoxStyles.block.flexBlock}
              title={`${lang.claimType}:`}
              subtitle={claimJob.claimType?.displayInfo?.title ?? 'N/A'}
            />
            <TextBox
              class={textBoxStyles.block.flexBlock}
              title={`${lang.status}:`}
              subtitle={lang[claimJob.statusCode]?.replace(/_/g, ' - ') ?? 'N/A'}
            />
            <TextBox
              class={textBoxStyles.block.flexBlock}
              title={`${lang.customerComplaint}:`}
              subtitle={claimJob.customerComplaint ?? 'N/A'}
            />
            <TextBox
              class={textBoxStyles.block.flexBlock}
              title={`${lang.causeOfFailure}:`}
              subtitle={claimJob.cause ?? 'N/A'}
            />
            <TextBox
              class={textBoxStyles.block.flexBlock}
              title={`${lang.correctionDetails}:`}
              subtitle={claimJob.correction ?? 'N/A'}
            />
            <TextBox
              class={textBoxStyles.block.flexBlock}
              title={`${lang.paymentDate}:`}
              subtitle={
                claimJob?.paymentDateUtc ? localizeDate(claimJob?.paymentDateUtc, defaultDateTimeFormat) : 'N/A'
              }
            />
            <TextBox
              class={textBoxStyles.block.flexBlock}
              title={`${lang.decidedDate}:`}
              subtitle={
                claimJob?.decidedDateUtc ? localizeDate(claimJob?.decidedDateUtc, defaultDateTimeFormat) : 'N/A'
              }
            />
          </Box>
          <br />
          {!!claimJob?.dataPoints && (
            <ObjectTable
              paths={[]}
              data={claimJob?.dataPoints}
              renderRow={({ data: row }) => (
                <tr key={row.claimTypeDataPointId}>
                  <td>{row.name ?? 'N/A'}</td>
                  <td>
                    {row.type === ClaimTypeDataPointInputType.Boolean ? (
                      <Icon class={row.value === 'true' ? 'fas-check' : 'fas-times'} />
                    ) : row.type === ClaimTypeDataPointInputType.Price ? (
                      <>
                        <Icon class="fas-dollar-sign" /> {row.value}
                      </>
                    ) : (
                      (row.value ?? 'N/A')
                    )}
                  </td>
                </tr>
              )}
            />
          )}
        </>
      )}
      {/*TODO: Add when needed*/}
      {/* {!!claimTypeReport && (
        <div style={paragraphStyles}>
          <DataMap
            data={claimTypeReport?.infoInputs}
            render={({ data: input }) => (
              <TextBox
                key={input.key}
                class={textBoxStyles.block.flexBlock}
                title={`${input.name[currentLanguage] || input.name[defaultLanguage]}:`}
                subtitle={report[input.key] ?? 'N/A'}
              />
            )}
          />
        </div>
      )} */}
    </>
  );
}
